import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_CORP_USER, IS_MOBILE_BROWSER, IS_PAID_USER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

type ModalSettings = {
    title: string;
    tariffsNumber: string;
    activeTab: string;
};

const defaultModalSettings: ModalSettings = {
    title: 'Облако и\u00A0Почта на\u00A0максимум с\u00A0подпиской Mail Space',
    tariffsNumber: '23',
    activeTab: 'y',
};

const nameShowAnalytics = 'modal-show';
const nameClickAnalytics = 'modal-click';

const segmentPersonalModal = !IS_CORP_USER && !IS_BIZ_USER && !IS_PAID_USER && !IS_MOBILE_BROWSER && !IS_WEBVIEW;

export const personalTariffsModalValue = getFeature('personal-tariffs-modal');

const personalTariffsModal: 'a' | 'b' = personalTariffsModalValue || 'a';

export const enabledPersonalTariffsModal = segmentPersonalModal && personalTariffsModal === 'b';

/** Кнопка "Увеличить место" */
const singleSpaceTariffs: ModalSettings = getFeature('single-space-tariffs');

export const singleSpaceModal = {
    paySource: 'personalization_add_space_cloud',
    name: 'mnz_personalization_add_space_cloud',
    enabled: enabledPersonalTariffsModal && !!singleSpaceTariffs,
    buyTitle: singleSpaceTariffs.title || defaultModalSettings.title,
    tariffsNumber: singleSpaceTariffs.tariffsNumber || defaultModalSettings.tariffsNumber,
    activeTab: singleSpaceTariffs.activeTab || defaultModalSettings.activeTab,
    actionShow: nameShowAnalytics,
    actionClick: nameClickAnalytics,
};

/** Загрузка тяжёлого файла */
const uploadBigFileTariffs: ModalSettings = getFeature('upload-bigfile-tariffs');

export const uploadBigFileModal = {
    paySource: 'personalization_heavy_file_cloud',
    name: 'mnz_personalization_heavy_file_cloud',
    enabled: enabledPersonalTariffsModal && !!uploadBigFileTariffs,
    buyTitle: uploadBigFileTariffs.title || defaultModalSettings.title,
    tariffsNumber: uploadBigFileTariffs.tariffsNumber || defaultModalSettings.tariffsNumber,
    activeTab: uploadBigFileTariffs.activeTab || defaultModalSettings.activeTab,
    actionShow: nameShowAnalytics,
    actionClick: nameClickAnalytics,
};

/** 256 гб в welcome-контенте (эмптистейт) */
const trialBlockTariffs: ModalSettings = getFeature('trial-block-tariffs');

export const trialBlockModal = {
    paySource: 'personalization_welcome_emptystate_cloud',
    name: 'mnz_personalization_welcome_emptystate_cloud',
    enabled: enabledPersonalTariffsModal && !!trialBlockTariffs,
    buyTitle: trialBlockTariffs.title || defaultModalSettings.title,
    tariffsNumber: trialBlockTariffs.tariffsNumber || defaultModalSettings.tariffsNumber,
    activeTab: trialBlockTariffs.activeTab || defaultModalSettings.activeTab,
    actionShow: nameShowAnalytics,
    actionClick: nameClickAnalytics,
};

/** Кнопка "Отключить рекламу" */
const disableButtonTariffsNew: ModalSettings = getFeature('disable-button-tariffs-new');

export const disableButtonModalNew = {
    paySource: 'personalization_disable_ads_cloud',
    name: 'mnz_personalization_disable_ads_cloud',
    enabled: enabledPersonalTariffsModal && !!disableButtonTariffsNew,
    buyTitle: disableButtonTariffsNew.title || defaultModalSettings.title,
    tariffsNumber: disableButtonTariffsNew.tariffsNumber || defaultModalSettings.tariffsNumber,
    activeTab: disableButtonTariffsNew.activeTab || defaultModalSettings.activeTab,
};

/** Мини-баннер в боковом меню "1тб на месяц" */
const trialPromoTariffs: ModalSettings = getFeature('trial-promo-tariffs');

export const trialPromo1TbModal = {
    paySource: 'personalization_1tb_sidebanner_cloud',
    name: 'mnz_personalization_1tb_sidebanner_cloud',
    enabled: enabledPersonalTariffsModal && !!trialPromoTariffs,
    buyTitle: trialPromoTariffs.title || defaultModalSettings.title,
    tariffsNumber: trialPromoTariffs.tariffsNumber || defaultModalSettings.tariffsNumber,
    activeTab: trialPromoTariffs.activeTab || defaultModalSettings.activeTab,
    actionShow: nameShowAnalytics,
    actionClick: nameClickAnalytics,
};

if (enabledPersonalTariffsModal) {
    registerExperiment(
        'personal',
        personalTariffsModalValue,
        [
            AnalyticEventNames.BUY_FAST_CHECKOUT_VIEW,
            AnalyticEventNames.BUY_FAST_CHECKOUT_CLICK_PAY,
            AnalyticEventNames.BUY_DISABLE_ADS_MODAL_SHOWN,
            AnalyticEventNames.BUY_DISABLE_ADS_MODAL_TARIFF_CLICK,
            AnalyticEventNames.DISABLE_BUTTON_SHOW,
            AnalyticEventNames.DISABLE_BUTTON_CLICK,
            AnalyticEventNames.QUOTA_BLOCK_SPACE_BUTTON_VIEW,
            AnalyticEventNames.QUOTA_BLOCK_SPACE_BUTTON_CLICK,
            AnalyticEventNames.BIG_FILE_DIALOG_SHOW,
            AnalyticEventNames.BIG_FILE_DIALOG_CLICK,
            AnalyticEventNames.WELCOME_TRIAL_BANNER_SHOW,
            AnalyticEventNames.WELCOME_TRIAL_BANNER_CLICK,
            AnalyticEventNames.SIDEBAR_TRIAL_BANNER_SHOW,
            AnalyticEventNames.SIDEBAR_TRIAL_BANNER_CLICK,
        ],
        {
            sendPlatformData: false,
            mapEventNames: {
                [AnalyticEventNames.BUY_FAST_CHECKOUT_VIEW]: 'view',
                [AnalyticEventNames.BUY_FAST_CHECKOUT_CLICK_PAY]: 'pay',
                [AnalyticEventNames.BUY_DISABLE_ADS_MODAL_SHOWN]: 'm-show',
                [AnalyticEventNames.BUY_DISABLE_ADS_MODAL_TARIFF_CLICK]: 'm-click',
                [AnalyticEventNames.DISABLE_BUTTON_SHOW]: 'dis_button_show',
                [AnalyticEventNames.DISABLE_BUTTON_CLICK]: 'dis_button_click',
                [AnalyticEventNames.QUOTA_BLOCK_SPACE_BUTTON_VIEW]: 'add_space_show',
                [AnalyticEventNames.QUOTA_BLOCK_SPACE_BUTTON_CLICK]: 'add_space_click',
                [AnalyticEventNames.BIG_FILE_DIALOG_SHOW]: 'big_file_show',
                [AnalyticEventNames.BIG_FILE_DIALOG_CLICK]: 'big_file_click',
                [AnalyticEventNames.WELCOME_TRIAL_BANNER_SHOW]: 'trial256-show',
                [AnalyticEventNames.WELCOME_TRIAL_BANNER_CLICK]: 'trial256-click',
                [AnalyticEventNames.SIDEBAR_TRIAL_BANNER_SHOW]: 'trial1tb-show',
                [AnalyticEventNames.SIDEBAR_TRIAL_BANNER_CLICK]: 'trial1tb-click',
            },
            sendXrayArgs: {
                [AnalyticEventNames.BUY_DISABLE_ADS_MODAL_SHOWN]: ({ modal }, { eventName }) => ({
                    eventName: `${eventName}_${modal}`,
                }),
                [AnalyticEventNames.BUY_DISABLE_ADS_MODAL_TARIFF_CLICK]: ({ modal }, { eventName }) => ({
                    eventName: `${eventName}_${modal}`,
                }),
                [AnalyticEventNames.BUY_FAST_CHECKOUT_VIEW]: ({ paySource }, { eventName }) => ({
                    eventName: `${eventName}_${paySource}`,
                }),
                [AnalyticEventNames.BUY_FAST_CHECKOUT_CLICK_PAY]: ({ paySource }, { eventName }) => ({
                    eventName: `${eventName}_${paySource}`,
                }),
            },
        }
    );
}
